
import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import AppBar from './AppBar';
import { useLocation, matchPath } from 'react-router-dom';
import Navbar from './Navbar';
import AdminAppBar from '../admin/AdminAppBar'
import AdminAppBarUnauthenticated from '../admin/AdminAppBarUnauthenticated';
import AppFooter from './AppFooter';
import PublicAnnouncement from '../announcements/PublicAnnouncement';
import { useAuth } from '../../contexts/AuthContext'

const publicRoutes = ['/', '/login', '/signup', '/contact-us',
  '/fundraise-campaigns', '/fundraise-campaigns/:id',
  '/events', '/events/:id'
];

const adminRoutes = ['/admin/dashboard', '/admin/onboard-employee', '/admin/users', '/admin/employees', '/admin/groups', '/admin/tickets',
  '/admin/accounting', '/admin/fundraisers', '/admin/events', '/admin/settings', '/admin/fundraisers/:id', '/admin/events/:id'];

const adminRoutesUnauthenticated = ['/admin/login', '/admin/onboarding/login', '/admin/onboarding/registration'];


const Layout = ({ children, toggleDarkMode, darkMode }) => {
  const location = useLocation();
  const { user } = useAuth();

  const isPublicRoute = publicRoutes.some(route => {
    if (route.includes(':id')) {
      const basePath = route.replace('/:id', '');
      return location.pathname.startsWith(basePath);
    }
    if (route.includes(':token')) {
      const basePath = route.replace('/:token', '');
      return location.pathname.startsWith(basePath);
    }
    return location.pathname === route;
  });

  const isAdminRoute = adminRoutes.some(route => {
    if (route.includes(':id')) {
      const basePath = route.replace('/:id', '');
      return location.pathname.startsWith(basePath);
    }
    return location.pathname.startsWith(route);
  });

  const isAdminRoutesUnauthenticated = adminRoutesUnauthenticated.some(route => {
    if (route.includes(':id')) {
      const basePath = route.replace('/:id', '');
      return location.pathname.startsWith(basePath);
    }
    return location.pathname.startsWith(route);
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      {isPublicRoute ? (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1000 }}>
          <Navbar toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
        </Box>
      ) : isAdminRoute ? (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1000 }}>
          <AdminAppBar toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
        </Box>
      ) : isAdminRoutesUnauthenticated ? (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1000 }}>
          <AdminAppBarUnauthenticated toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
        </Box>
      ) : (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1000 }}>
          {user ? (
            location.pathname.includes('/admin') ? (
              <AdminAppBarUnauthenticated toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
            ) : (
            <AppBar toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
            )
          ) : (
            <Navbar toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
          )}
        </Box>
      )}
      <PublicAnnouncement />
      <Box component="main" sx={{ flexGrow: 1, overflowY: 'auto' }}>
        {children}
      </Box>
      <AppFooter />
    </Box>
  );
};

export default Layout;